import { createStore } from 'vuex';
import news from './modules/news';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    news,
  },
});
